export default __webpack_public_path__ + "static/media/portfolio-madrid-1.3188d3b3.jpg";